<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8" v-if="this.$store.getters.application.applicationType === 'platform'">
            <a-form-item :label="language['premission.applicationName']">
              <a-select v-model="queryParam.applicationId" allowClear @change="applicationChange" >
                <a-select-option v-for="(application,index) in allApplication" :key="index.toString()" :value="application.id">
                  {{ application.applicationName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.processName']">
              <!--<a-input placeholder="请输入账号查询" v-model="queryParam.username"></a-input>-->
              <a-select v-model="queryParam.modelGuid" allowClear >
                <a-select-option v-for="(process,index) in allProcess" :key="index" :value="process.processModelGuid" >{{ process.processModelName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.businessFormNo']">
              <a-input  v-model="queryParam.bussinessFormNo" allowClear></a-input><!--placeholder="输入流程编号"-->
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.processNo']">
              <a-input  v-model="queryParam.processNo" allowClear></a-input><!--placeholder="输入流程编号"-->
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="this.language['eletronicSigned.processStatus']">
              <!--              <a-input  v-model="queryParam.processStatus" allowClear></a-input>-->
              <a-select v-model="queryParam.processStatus" allowClear>
                <a-select-option value="Completed">{{language['eletronicSigned.processStatus.Completed']}}</a-select-option>
                <a-select-option value="InProcess">{{language['eletronicSigned.processStatus.InProcess']}}</a-select-option>
                <a-select-option value="Restarted">{{language['eletronicSigned.processStatus.Restarted']}}</a-select-option>
                <a-select-option value="Started">{{language['eletronicSigned.processStatus.Started']}}</a-select-option>
                <a-select-option value="Withdrawn">{{language['eletronicSigned.processStatus.Withdrawn']}}</a-select-option>
                <a-select-option value="Rejected">{{language['eletronicSigned.processStatus.Rejected']}}</a-select-option>
                <a-select-option value="Cancelled">{{language['eletronicSigned.processStatus.Cancelled']}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.createrWorkNo']">
              <a-input  v-model="queryParam.createUserCode" allowClear></a-input><!--placeholder="输入流程编号"-->
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.creater']">
              <a-input  v-model="queryParam.createUserName" allowClear></a-input><!--placeholder="输入流程编号"-->
            </a-form-item>
          </a-col>
<!--          <a-col :md="6" :sm="12">
            <a-form-item :label="this.language['eletronicSigned.signWorkNo']">
              <a-input  v-model="queryParam.approverCode" allowClear></a-input>&lt;!&ndash;placeholder="输入流程编号"&ndash;&gt;
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="this.language['eletronicSigned.signPerson']">
              <a-input  v-model="queryParam.approverName" allowClear></a-input>&lt;!&ndash;placeholder="输入流程编号"&ndash;&gt;
            </a-form-item>
          </a-col>-->
          <!--<a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.affiliationApplication']">
              <a-select v-model="queryParam.application_code" allowClear >
                <a-select-option v-for="(process,index) in allApplication" :key="index" :value="process.processApplicationCode" >{{ process.processApplicationName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>-->
          <a-col :xl="10" :lg="11" :md="12" :sm="24">
            <a-form-item :label="language['eletronicSigned.startTime']">
              <j-date :placeholder="language['common.chooseStartDate']" :showTime="false"
                      :allowClear="false"
                      :defaultValue="moment(queryParam.beginDate, 'YYYY-MM-DD')" dateFormat="YYYY-MM-DD"
                      class="query-group-cust" v-model="queryParam.beginDate"></j-date>
              <span class="query-group-split-cust"></span>
              <j-date :placeholder="language['common.chooseEndDate']" :showTime="false"
                      :allowClear="false"
                      :defaultValue="moment(queryParam.endDate, 'YYYY-MM-DD')" dateFormat="YYYY-MM-DD"  class="query-group-cust" v-model="queryParam.endDate"></j-date>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="search_reset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <!--<a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>-->
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <!--<div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a style="font-weight: 600">{{
        selectedRowKeys.length }}</a>项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>-->

      <a-table
        ref="table"
        bordered
        size="middle"

        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"

        @change="handleTableChange">
<!--        :scroll="{x:1000}"-->
        <!--rowKey="id"-->
        <!--:rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"-->

        <template slot="processChartLot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <!--<a-avatar @click="openChart(record.processGuid)" shape="square" icon="user"/>-->
            <a-icon type="cluster" @click="openChart(record.processGuid)" style="color:#33A1FF"/>
            <j-modal
              switchFullscreen
              :mask="false"
              :width="1000"
              :title="language['eletronicSigned.processChart']"
              :visible="visible"
              :confirm-loading="confirmLoading"
              :ok-button-props="{ props: { disabled: true } }"
              @cancel="handleCancel"
              :ok-disabled="true"
              :cancelText="language['common.closeButton']">
              <img style="width: 100%;" :src="imgChartSrc"><!--'be00c9ad-45e8-a5c4-9c83-1523494a8a70'-->
            </j-modal>
          </div>
        </template>

        <span slot="action" slot-scope="text, record">

<!--          <a @click="handleEdit(record)" v-if="record.processStatus!=='Withdrawn'&&record.processStatus!=='Rejected'">{{language['eletronicSigned.check']}}</a>
          <a-divider type="vertical" v-if="record.processStatus!=='Withdrawn'&&record.processStatus!=='Rejected'"/>-->
          <a  @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
<!--          <a-divider type="vertical" v-if="record.processStatus==='Withdrawn'||record.processStatus==='Rejected'"/>
          <a @click="termination(record)" v-if="record.processStatus==='Withdrawn'||record.processStatus==='Rejected'">{{language['eletronicSigned.termination']}}</a>-->
          <!--<a-divider type="vertical" v-if="record.processStatus==='Withdrawn'||record.processStatus==='Rejected'"/>
          <a @click="deleteProcess(record)" v-if="record.processStatus==='Withdrawn'||record.processStatus==='Rejected'">删除</a>-->
          <!--<a-dropdown>
            <a class="ant-dropdown-link">
              更多 <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>-->
        </span>
        <span slot="processStatus" slot-scope="text, record">
          <!--{{ text === 'Cancelled' ? language['eletronicSigned.termination'] : record.process_status_local_lang }}-->
          <div style="color: red;font-weight: 500;" v-if="record.processStatus === 'Rejected'||record.processStatus === 'ReturnTo'">
<!--             {{ text === 'Cancelled' ? language['eletronicSigned.termination'] : record.process_status_local_lang }}-->
            {{language['eletronicSigned.processStatus.Rejected']}}
           </div>
          <div v-else-if="record.processStatus === 'Cancelled'">{{language['eletronicSigned.processStatus.Cancelled']}}</div>
          <div v-else-if="record.processStatus === 'InProcess'">{{language['eletronicSigned.processStatus.InProcess']}}</div>
          <div v-else-if="record.processStatus === 'Completed'">{{language['eletronicSigned.processStatus.Completed']}}</div>
          <div v-else-if="record.processStatus === 'Restarted'">{{language['eletronicSigned.processStatus.Restarted']}}</div>
          <div v-else-if="record.processStatus === 'Started'">{{language['eletronicSigned.processStatus.Started']}}</div>
          <div v-else-if="record.processStatus === 'Withdrawn'">{{language['eletronicSigned.processStatus.Withdrawn']}}</div>
<!--          <div  v-else>{{ text === 'Cancelled' ? language['eletronicSigned.termination'] : record.process_status_local_lang }}</div>-->
        </span>
        <span slot="taskStatus" slot-scope="text, record">
          {{ text === 'Cancelled' ? language['eletronicSigned.termination'] : record.task_status_local_lang }}
        </span>


      </a-table>
    </div>
    <!-- table区域-end -->

    <todo-task-modal ref="modalForm" @reSeach="searchQuery" @ok="modalFormOk"></todo-task-modal>
    <my-todo-comments-modal ref="myTodoCommentsModal"  @reSeach="searchQuery"></my-todo-comments-modal>

  </a-card>
</template>

<script>
import TodoTaskModal from './modules/TodoTaskModal'
import MyTodoCommentsModal from './modules/MyTodoCommentsModal'
import {putAction, getFileAccessHttpUrl,getAction} from '@/api/manage';
import {frozenBatch} from '@/api/api'
import {JeecgListMixin} from '@/mixins/JeecgListMixin'
import JInput from '@/components/jeecg/JInput'
import JSuperQuery from '@/components/jeecg/JSuperQuery'
import ACol from "ant-design-vue/es/grid/Col";
import AFormItem from "ant-design-vue/es/form/FormItem";
import {cancel} from "./auditJS/cancel"
import moment from 'moment'
import { ACCESS_TOKEN,USER_LANGUAGE } from "@/store/mutation-types"

export default {
  name: "AllProcess",
  mixins: [JeecgListMixin],
  components: {
    AFormItem,
    ACol,
    TodoTaskModal,
    MyTodoCommentsModal,
    JInput,
    JSuperQuery
  },
  data() {
    return {
      langCode:window.sessionStorage.getItem(USER_LANGUAGE),
      allProcess:[],
      allApplication:[],
      imgChartSrc:"",
      processChartPrefix: "",
      processChartSuffix: "",
      processGuid: "",
      visible: false,
      confirmLoading: false,
      queryParam: {
        beginDate: this.getBeginDate(),
        endDate: this.getEndDate()
        // application_code:this.$store.getters.applicationCode,
        // bussinessFormNo:'',
      },
      recycleBinVisible: false,
      cancelData:{},
      url: {
        list: "/sys/processSigned/pfBpmProcess/allProcessPage",
      },
      /* 分页参数 */
      ipagination:{
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] +" "+ this.$store.getters.language['common.total']+" " + total +" "+ this.$store.getters.language['common.strip']
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
    }
  },
  created() {
    // this.initAllprocessAndapplication()
    this.initApplication();
    this.initModel();
    getAction("/sys/wfapi/getProcessChart",{}).then(res=>{
      if (res.success) {
        this.processChartPrefix=res.result.prefix;
        this.processChartSuffix = res.result.suffix;
      }
    })
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    columns() {
      if (this.language) {
        return [
          {
            title: this.language['eletronicSigned.processNo'],
            align: "center",
            dataIndex: 'processNo',
            width: 150,
            sorter: true
          },
          {
            title: this.language['eletronicSigned.processName'],
            align: "center",
            dataIndex: 'processName',
            width: 200,
            sorter: true,
            customRender: function (text, r, index) {
                if(window.sessionStorage.getItem(USER_LANGUAGE) === "zh_CN" || window.sessionStorage.getItem(USER_LANGUAGE) === "zh_TW"){
                  return r.processNameLocalLang;
                }else{
                  return r.processNameEn;
                }
              }
          },
          {
            title: this.language['eletronicSigned.processStatus'],
            align: "center",
            width: 100,
            dataIndex: 'processStatus',
            // customRender: function (text, r, index) {
            //   if (text === 'Cancelled') {
            //     // return this.tt.language['eletronicSigned.termination']
            //     // return this.termination;
            //     // return '终止'
            //     // return this.getLanguage('eletronicSigned.termination')
            //     return this.language['eletronicSigned.processName'];
            //     // return this.language('eletronicSigned.termination');
            //   } else {
            //     return r.process_status_local_lang;
            //   }
            // }
            scopedSlots: {customRender: 'processStatus'},
          },
          {
            title: this.language['eletronicSigned.businessFormNo'],
            align: "center",
            width: 250,
            dataIndex: 'bussinessFormNo',
          },
          /*{
            title: this.language['eletronicSigned.taskText'],
            align: "center",
            width: 150,
            dataIndex: 'taskName',
          },*/
          /*{
            title: this.language['eletronicSigned.taskStatus'],
            align: "center",
            width: 150,
            dataIndex: 'taskStatus',
            scopedSlots: {customRender: 'taskStatus'},
          },*/
          {
            title: this.language['eletronicSigned.createrWorkNo'],
            align: "center",
            width: 150,
            dataIndex: 'createUserCode'
          },
          {
            title: this.language['eletronicSigned.creater'],
            align: "center",
            width: 150,
            dataIndex: 'createUserName'
          },
          {
            title: this.language['eletronicSigned.startTime'],
            align: "center",
            width: 150,
            dataIndex: 'createTime'
          },
          {
            title: this.language['eletronicSigned.processChart'],
            align: "center",
            width: 100,
            dataIndex: 'processGuid',
            scopedSlots: {customRender: "processChartLot"}
          },
          /*{
            title: this.language['eletronicSigned.urgentDegree'],
            align: "center",
            width: 150,
            dataIndex: 'urgent_degree'
          },*/
          /*{
            title: this.language['eletronicSigned.signWorkNo'],
            align: "center",
            width: 160,
            dataIndex: 'approverCode'
          },
          {
            title: this.language['eletronicSigned.signPerson'],
            align: "center",
            width: 160,
            dataIndex: 'approverName'
          },*/
          {
            title: this.language['eletronicSigned.affiliationApplication'],
            align: "center",
            dataIndex: 'applicationName'
          },
          {
            title: this.language['common.action'],
            dataIndex: 'action',
            scopedSlots: {customRender: 'action'},
            align: "center",
            width: 170,
            fixed: "right"
          }

        ]
      }
    }
  },
  methods: {
    moment,
    handleEdit(record){
      this.$refs.modalForm.title = this.language['eletronicSigned.check'];
      record.setEdit = true;
      this.$refs.modalForm.edit(record);
    },
    search_reset() {
      if(this.$store.getters.application.applicationType === 'platform'){
        this.queryParam ={
          beginDate: this.getBeginDate(),
          endDate: this.getEndDate()
          // application_code:this.$store.getters.applicationCode,
        }
      }else{
        this.queryParam ={
          beginDate: this.getBeginDate(),
          endDate: this.getEndDate(),
          applicationId:this.$store.getters.application.id,
        }
      }
      this.loadData(1);
    },
    change(e){
      this.searchQuery();
      // alert(e.target.value);
    },
    termination(record){
      /*let map = {};
      map.pfBpmProcessId = record.processGuid;
      map.workNo = this.$store.getters.userInfo.workNo;
      map.approveAction = "Cancel";
      map.taskCode = record.task_code;
      this.cancelData = map;
      this.$refs.myTodoCommentsModal.edit(map);*/
      getAction("/sys/processSigned/pfBpmModel/queryBymodelGuId?modelGuId="+record.modelGuid,{}).then(res=>{
        if (res.success) {
          cancel(res.result.applicationCode,this,record)
        }
      })
    },

    deleteProcess(record){
      this.$confirm({
        title: this.language['common.delete'],
        content: this.language['tip.promptMessageDelete'],
        centered: true,
        onOk: () => {
          let param = {};
          param.formNo = record.businessFormNo;
          param.modelCode = record.model_code;
          getAction("/sys/wfapi/pageTodeleteProcess", param).then((res) => {
            if(res.success){
              this.searchQuery();
            }else{
              this.$message.warning(this.language['operationfailed']);
            }
          })
        }
      })
    },
    getAvatarView: function (avatar) {
      return getFileAccessHttpUrl(avatar)
    },
    openChart(processGuid) {
      this.visible = true;
      this.imgChartSrc = this.processChartPrefix + processGuid + this.processChartSuffix;
      if(this.imgChartSrc.split("?").length>1){
        this.imgChartSrc = this.imgChartSrc + "&timestamp="+ new Date().getTime();
      }else{
        this.imgChartSrc = this.imgChartSrc + "?timestamp="+ new Date().getTime();
      }
      // window.open(this.processChartPrefix + processGuid + this.processChartSuffix);
    },
    handleCancel(e) {
      this.visible = false;
      // this.imgChartSrc = "";
    },
    initApplication(){
      if(this.$store.getters.application.applicationType === 'platform'){
        getAction("/sys/sysBmApplication/queryList").then((res) => {
          if (res.success) {
            this.allApplication = res.result;
          }
        })
      }
    },
    applicationChange(v){
      if(v){
        this.initModel(v);
      }else{
        this.allProcess = [];
        if(this.queryParam.modelGuid){
          this.queryParam.modelGuid = ""
        }
      }
    },
    initModel(applicationId) {
      if(this.$store.getters.application.applicationType !== 'platform'){
        applicationId = this.$store.getters.application.id;
      }
      if(applicationId){
        getAction("/sys/processSigned/pfBpmModel/listWithOutPage", {applicationId:applicationId}).then((res) => {
          if (res.success) {
            let processlist = [];
            res.result.forEach(item=> {
              let processmap = {};
              processmap.processModelGuid = item.modelGuid;
              if(window.sessionStorage.getItem(USER_LANGUAGE) === "zh_CN" || window.sessionStorage.getItem(USER_LANGUAGE) === "zh_TW"){
                processmap.processModelName = item.modelNameLocalLang;
              }else{
                processmap.processModelName = item.modelNameEn;
              }
              processlist.push(processmap);
            })
            this.allProcess = processlist;
          }
        })
      }

    },
    initAllprocessAndapplication(){
      getAction("/sys/processSigned/pfBpmModel/listWithOutPage").then((res) => {
        if (res.success) {
          let processlist = [];
          let applicationlist = [];
          let set = [];
          res.result.forEach(item=>{
            let processmap = {};
            processmap.processModelGuid = item.modelGuid;
            processmap.processModelName = item.modelNameLocalLang;
            processlist.push(processmap);
            if(set.indexOf(item.applicationCode) === -1){
              let applicationmap = {};
              applicationmap.id = item.applicationId;
              applicationmap.processApplicationCode = item.applicationCode;
              applicationmap.processApplicationName = item.applicationName;
              applicationlist.push(applicationmap);
              set.push(item.applicationCode);
            }
          })
          this.allProcess = processlist;
          this.allApplication = applicationlist;
        } else {
        }
      })
    },
    getBeginDate(){
      let date= new Date();
      date.setMonth(date.getMonth() - 1)
      let day = date.getDate()>9?date.getDate():'0'+date.getDate();
      // let month = date.getMonth()>9?date.getMonth():(date.getMonth()!==0?'0'+date.getMonth():0);
      let month = date.getMonth()+1>9?date.getMonth()+1:'0'+(date.getMonth()+1);
      let year = date.getFullYear();
      /*if(month===0){
        year = year-1;
        month = 12;
      }*/
      return year+'-'+month+'-'+day+' 00:00:01';
    },
    getEndDate(){
      let date= new Date();
      let day = date.getDate()>9?date.getDate():'0'+date.getDate();
      let year = date.getFullYear()
      let month = date.getMonth()+1>9?date.getMonth()+1:'0'+(date.getMonth()+1);
      return year+'-'+month+'-'+day+' 23:59:59';
    }
  }

}
</script>
<style scoped>
@import '~@assets/less/common.less'
</style>